import { render } from "./ClientTsor.vue?vue&type=template&id=bb193f82"
import script from "./ClientTsor.vue?vue&type=script&lang=js"
export * from "./ClientTsor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__